module.exports = {
  isNonProd() {
    const {
      VUE_APP_VERCEL_GIT_COMMIT_REF,
      VERCEL_ENV,
      VERCEL_URL
    } = process.env
    // env vars get converted to string, therefore checking 'undefined'

    if (
      VUE_APP_VERCEL_GIT_COMMIT_REF === "undefined" ||
      VERCEL_ENV === "undefined"
    )
      return false

    const isProduction =
      VUE_APP_VERCEL_GIT_COMMIT_REF === "master" &&
      VERCEL_ENV === "production" &&
      !VERCEL_URL.includes("staging")

    const isSandbox = VERCEL_URL.includes("sandbox")

    return !(isProduction || isSandbox)
  },
  isStagingVercel(vercelStagingProjectName) {
    const branchName = process.env.VUE_APP_VERCEL_GIT_COMMIT_REF
    if (branchName === "sandbox") {
      return false
    }
    const VERCEL_PREVIEW_SUFFIX = ".preview.soenergy.co"
    return JSON.stringify(process.env.VUE_APP_VERCEL_URL || "")
      .split(VERCEL_PREVIEW_SUFFIX)[0]
      .includes(vercelStagingProjectName)
  }
}
